import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { ResponseContentType }    from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class HechoService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
    ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'hecho'].join('/');
  }

  public order(fechas) {
    return this.http
    .get([this.ApiUrl,'order',fechas].join('/'))
    .map(res => res.json());
  }

  public orderf(orden) {
    return this.http
    .get([this.ApiUrl,'orderf',orden].join('/'))
    .map(res => res.json());
  }

  public getExportarHecho() {
    this.validate();
    return this.http
      .get([
        this.ApiUrl,'exportar'].join('/'), { responseType: ResponseContentType.Blob });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/hecho/hecho.service.ts